// extracted by mini-css-extract-plugin
export default {"div_counter_wrap":"InputNumber_div_counter_wrap__2c0ds","img_count":"InputNumber_img_count__7U3uY"};